import { StyleSheet } from 'aphrodite';
import { charmGray, success } from '../../../../web/styles/colors';
import { THEME } from '../../../../web/components-v2/Theme/theme';

const { colors } = THEME;

export const styleSheet = StyleSheet.create({
	trigger: {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 40,
		height: 40,
		borderRadius: 20,
		border: 'none',
		backgroundColor: colors.primary.light,
		color: colors.primary.main,
		cursor: 'pointer',
		transition: 'background-color 0.2s ease',
		':hover': {
			backgroundColor: colors.hover.light,
		},
	},
	triggerActive: {
		color: colors.primary.contrastText,
		backgroundColor: colors.primary.main,
		':hover': {
			backgroundColor: colors.primary.main,
		},
		':after': {
			content: '""',
			position: 'absolute',
			top: 0,
			left: -8,
			backgroundColor: colors.primary.main,
			width: 4,
			borderRadius: '0 2px 2px 0',
			height: '100%',
		},
	},
	triggerDisabled: {
		opacity: 0.5,
		pointerEvents: 'none',
	},
	icon: {
		width: 20,
		height: 20,
	},
	activeSessionItem: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		fontWeight: 600,
	},
	activeSessionIndicator: {
		width: 8,
		height: 8,
		borderRadius: '50%',
		backgroundColor: success,
		animation: 'pulse 2s infinite',
	},
	loadingContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		padding: '8px 12px',
		color: charmGray,
		fontSize: 13,
	},
	emptyState: {
		padding: '12px 16px',
		color: charmGray,
		fontSize: 13,
		fontStyle: 'italic',
	},
	conversationItem: {
		display: 'flex',
		flexDirection: 'column',
		gap: 2,
	},
	conversationInfo: {
		display: 'flex',
		flexDirection: 'column',
	},
	conversationDate: {
		fontSize: 13,
		color: '#333',
	},
});
